<template>
	<div class="guide-travel-page page-bg">
		<div class="body">
			<div class="box">
				<Calendar
					ref="Calendar"
					v-on:choseDay="clickDay"
					v-on:changeMonth="changeDate"
					:markDateMore="markDateList"
					:agoDayHide="agoDayHide"
				></Calendar>
			</div>
			<div class="state-introduce">
				<div>
					<div
						class="step"
						style="background-color: #ff3333; margin-right: 4px"
					></div>
					<div>已接团</div>
				</div>
				<div>
					<div
						class="step"
						style="background-color: #00cb8b; margin-right: 4px"
					></div>
					<div>可接团</div>
				</div>
				<div>
					<div
						class="step"
						style="background-color: #ff8000; margin-right: 4px"
					></div>
					<div>不接团</div>
				</div>
			</div>

			<div class="input-box box">
				<div class="time-box">
					<div class="title">当前选择时间</div>
					<div class="title flex1" style="padding: 0 10px">
						{{
							selectDateList.length > 0
								? selectDateStr
								: '暂未选择'
						}}
					</div>
				</div>
				<div class="title">选择接团状态</div>
				<div class="tag-box">
					<!-- <div
						class="tag"
						:class="{ active: selectActive === 1 }"
						@click="selectActive = 1"
					>
						已接团
					</div> -->
					<div
						class="tag"
						:class="{ active: selectActive === 3 }"
						@click="onSelectActiveChange(3)"
					>
						不接团
					</div>
					<div
						class="tag"
						:class="{ active: selectActive === 2 }"
						@click="onSelectActiveChange(2)"
					>
						可接团
					</div>
				</div>
			</div>
			<van-button
				color="#3377ff"
				type="primary"
				block
				@click="saveJourney"
				>保存行程</van-button
			>
		</div>
	</div>
</template>

<script>
import Calendar from 'vue-calendar-component'
import { parseTime } from '@/utils'
import { Notify } from 'vant'
export default {
	components: { Calendar },
	data() {
		return {
			agoDayHide: '0',
			timeObject: {}, // 月份数据
			selectDateList: [], // 当前选中的
			selectActive: 3,
			markDateList: [], // 所有有身份的日期
		}
	},
	computed: {
		selectDateStr() {
			return this.selectDateList
				.map((res) => {
					return parseTime(res, '{yyyy}年{mm}月{dd}日')
				})
				.join('、')
		},
	},
	mounted() {
		var date = new Date()
		this.agoDayHide = parseInt(date.getTime() / 1000) + ''
		this.init(date)
	},
	methods: {
		init(date) {
			var time = parseTime(date, '{yyyy}-{mm}-{dd}')
			this.$API.guide
				.upgradeJourney({ date: time })
				.then((res) => {
					//type - SELF 自己设置的 SYSTem 系统的不可更改
					// 状态 OCCUPY-占用  IDLE-空闲 SELECTED-选中
					var timeList = res.data
					// 存储请求过月份
					const key = time.substr(0, 7)
					this.timeObject[key] = timeList

					// 改变有状态的 className
					timeList.forEach((element) => {
						var obj = {
							date: element.date,
							type: element.type
						}
						if (element.type === 'SELF') {
							obj.className = 'self'
						} else {
							if (
								element.status === 'OCCUPY' ||
								element.status === 'SELECTED'
							) {
								obj.className = 'occupy'
							} else {
								obj.className = 'idle'
							}
						}
						this.markDateList.push(obj)
					})
				})
				.catch((err) => {})
		},
		saveJourney() {
			if (this.selectDateList.length <= 0) {
				Notify({ type: 'warning', message: '请选择日期' })
				return
			}
			//enable true：添加日期限制   false：取消日期限制
			//type: 目前仅支持一种：NOT_ACCEPT—设置不接单
			var data = {
				dateList: this.selectDateList,
				type: 'NOT_ACCEPT',
				enable: this.selectActive === 3,
			}
			this.$API.guide
				.updateJourneydate(data)
				.then((res) => {
					for (const s of this.selectDateList) {
						for (var m of this.markDateList) {
							if (s === parseTime(m.date, '{yyyy}-{mm}-{dd}')) {
								if (this.selectActive === 3) {
									m.className = 'self'
								} else {
									m.className = 'idle'
								}
							}
						}
					}
					this.selectDateList = []
				})
				.catch((err) => {})
		},
		changeDate(e) {
			const time = parseTime(e, '{yyyy}-{mm}-{dd}')
			const key = time.substr(0, 7)
			if (!this.timeObject[key]) {
				this.init(time)
			}
		},
		clickDay(e) {
			const time = parseTime(e, '{yyyy}-{mm}-{dd}')
			var index = this.selectDateList.indexOf(time)

			if (index >= 0) {
				// 选中的  去掉选中效果
				this.selectDateList.splice(index, 1)
				this.markDateList = this.markDateList.filter((res) => {
					if (parseTime(res.date, '{yyyy}-{mm}-{dd}') != time) {
						return true
					} else {
						if (res.oldClassName) {
							res.className = res.oldClassName
							return true
						}
					}
					return false
					// return parseTime(res.date, '{yyyy}-{mm}-{dd}') != time
				})
			} else {
				var list = this.markDateList.filter((res) => {
					return parseTime(res.date, '{yyyy}-{mm}-{dd}') === time
				})
				const key = time.substr(0, 7)
				const month = this.timeObject[key]
				if (month) {
					// 当前是可接团状态
					if (list.length <= 0) {
						if(this.selectActive === 2){
							Notify({ type: 'warning', message: '当前日期不可选' })
							return;
						}

						this.selectDateList.push(time)
						this.markDateList.push({
							date: time,
							className: 'select',
						})
					}else{
						const item = list[0]

						if(this.selectActive === 3 && item.type === 'SELF'){
							Notify({ type: 'warning', message: '当前日期不可选' })
							return;
						}

						if (item.type === 'SELF'){
							this.selectDateList.push(time)
							item.oldClassName = item.className;
							item.className = 'select'
						}else{
							Notify({ type: 'warning', message: '当前日期不可选' })
						}
					}
				} else {
					Notify({ type: 'warning', message: '当前日期不可选' })
				}
			}
		},

		onSelectActiveChange(val) {
			this.selectDateList.forEach(date => {
				const index = this.markDateList.findIndex(i => {
					return (date === parseTime(i.date, '{yyyy}-{mm}-{dd}'));
				});
				if(this.markDateList[index].type === 'SELF'){
					this.markDateList[index].className = 'self';
				}else{
					this.markDateList.splice(index, 1);
				}
			});
			this.selectDateList = [];

			this.selectActive = val;
		}
	},
}
</script>

<style lang="scss" scoped>
.guide-travel-page {
	height: 100%;
	.body {
		padding: 16px;
		box-sizing: border-box;
		height: 100%;
		overflow-y: scroll;
		.box {
			::v-deep .wh_container .wh_content_all {
				background-color: #ffffff !important;
				color: black;
			}
			::v-deep .wh_container .wh_item_date {
				color: #00cb8b;
			}

			::v-deep .wh_container .wh_item_date:hover {
				color: #00cb8b;
			}

			::v-deep .wh_container .wh_other_dayhide {
				color: #cccccc;
			}

			::v-deep .wh_container .wh_content_item {
				margin-bottom: 5px;
				margin-top: 5px;
			}

			::v-deep .wh_container .wh_content {
				color: black;
			}

			::v-deep .wh_container .wh_top_tag {
				color: black;
			}
			::v-deep .wh_container .wh_content_li {
				color: #162947;
				font-weight: bold;
			}
			::v-deep .wh_container .wh_jiantou1 {
				border-top: 2px solid #162947;
				border-left: 2px solid #162947;
			}
			::v-deep .wh_container .wh_jiantou2 {
				border-top: 2px solid #162947;
				border-right: 2px solid #162947;
			}

			::v-deep .wh_container .wh_content_item .wh_isMark {
				background-color: white;
				color: #00cb8b;
				/*border-radius: 0px;*/
			}
			::v-deep .wh_container .wh_content_item .wh_isToday {
				background-color: white;
				/*border-radius: 0px;*/
				color: #00cb8b;
			}
			::v-deep .wh_container .wh_content_item .wh_chose_day {
				background-color: white;
				/*border-radius: 0px;*/
				color: #00cb8b;
			}

			::v-deep .wh_container .wh_content_item .idle {
				color: #00cb8b;
			}
			::v-deep .wh_container .wh_content_item .self {
				background-color: #ff8000;
				border-radius: 50%;
				color: white;
			}

			::v-deep .wh_container .wh_content_item .occupy {
				background-color: #ff3333;
				border-radius: 50%;
				color: white;
			}
			::v-deep .wh_container .wh_content_item .select {
				border: 1px solid black;
				border-radius: 50%;
				color: black;
			}

			background-color: white;
			border-radius: 4px;
		}
		.state-introduce {
			display: flex;
			justify-content: space-evenly;
			height: 55px;
			align-items: center;
			color: #333;
			font-size: 15px;
			> div {
				display: flex;
				align-items: center;
			}
			.step {
				width: 12px;
				height: 12px;
				border-radius: 6px;
			}
		}

		.input-box {
			padding: 20px 16px;
			.time-box {
				display: flex;
				padding-bottom: 20px;
				border-bottom: 1px solid #eef0f3;
				margin-bottom: 20px;
			}
			.tag-box {
				display: flex;
				.tag {
					margin-top: 12px;
					margin-right: 6px;
					width: 84px;
					height: 34px;
					line-height: 34px;
					text-align: center;
					border-radius: 17px;
					background-color: #eef0f3;
					font-size: 13px;
					color: #333;
				}
				.active {
					color: #3377ff;
					border: 1px solid #3377ff;
				}
			}
			.title {
				font-size: 15px;
				color: #333;
				font-family: 'Source Han Sans CN';
				font-weight: bold;
			}
		}

		.van-button {
			margin-top: 40px;
			border-radius: 4px;
		}
	}
}
</style>
